/*
 * @Author: wangxiaoheng
 * @Date: 2023-12-07 15:33:32
 * @LastEditors: wangxiaoheng
 * @LastEditTime: 2023-12-11 15:46:41
 * @FilePath: \saas_dev\src\utils\api\wx.js
 * @Description: 
 * 
 * 
 */
import axios from "axios";
import { post } from "../https";

const api = "/xywapi";
export const appid = process.env.VUE_APP_WXAPPID; // "wxc0235f0505120768";
const secret = process.env.VUE_APP_WXAPPSECRET; // "cbb4d65c4d510d33a4f3623a223216e0";
/**
 * js SDK
 */
// 获取全局js调用 token
export async function getJSSKDAccessToken() {
  return axios.get(
    `/wxapi/cgi-bin/token?grant_type=client_credential&appid=${appid}&secret=${secret}`
  );
}
// 获取票据
export async function getTicket(access_token) {
  return axios.get(
    `/wxapi/cgi-bin/ticket/getticket?access_token=${access_token}&type=jsapi`
  );
}
// 通过票据 获取js签名 （本地 个人 nodejs 测试服务）
export async function getSignByTicket(data) {
  return axios.post(`/node/getwxsignature`, data);
}

// 通过 ticket 获取js签名 （后端服务）
export async function getWxJSSDKSignature(data) {
  return await post(`${api}/weixin/weixinShare`, data);
}

/**
 * 公众号&用户交互
 */
// 获取用户信息用 token
export async function getUserAccessToken(code) {
  return axios.get(
    `/wxapi/sns/oauth2/access_token?appid=${appid}&secret=${secret}&code=${code}&grant_type=authorization_code`
  );
}
// 获取微信用户信息
export async function getWxUserInfo(access_token, openid) {
  return axios.get(
    `/wxapi/sns/userinfo?access_token=${access_token}&openid=${openid}&lang=zh_CN`
  );
}
// https://api.weixin.qq.com/cgi-bin/user/info?access_token=ACCESS_TOKEN&openid=OPENID&lang=zh_CN
